import { render, staticRenderFns } from "./top-banner-svg-container.vue?vue&type=template&id=ddf1b5b4&scoped=true&"
import script from "./top-banner-svg-container.vue?vue&type=script&lang=js&"
export * from "./top-banner-svg-container.vue?vue&type=script&lang=js&"
import style0 from "./top-banner-svg-container.vue?vue&type=style&index=0&id=ddf1b5b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddf1b5b4",
  null
  
)

export default component.exports